import React, { useContext, useEffect } from "react";
import PsContext from "../../context";
import YouTubeVideo from "./YouTubeVideo";

const CampusTourVideo = (props) => {
  const context = useContext(PsContext);
  useEffect(() => {
    loadVideo();
  }, []);

  const loadVideo = () => {
    if (!isYouTube()) {
      var video = document.getElementById("myVideo");
      if (video) {
        video.currentTime = 0;
        video.play();
      }
    }
  };
  document.addEventListener("DOMContentLoaded", function () {
    if (!isYouTube()) {
      var video = document.getElementById("myVideo");
      if (video) {
        video.addEventListener("ended", function () {
          video.currentTime = 0;
          video.play();
        });
      }
    }
  });

  const field = (fieldName) => props?.dataSource?.[fieldName];

  const isYouTube = (inputValue = "no") => inputValue.includes("youtube");

  return (
    <>
      <section className="ps_testimonials">
        <div className="container">
          <div className="row">
            <div className=" p-3 col-xs-12 col-md-12">
              <h5
                className="text-center"
                style={{
                  color: `${context.settingValue("web_site_header_textcolor")}`,
                }}
              >
                Campus Tour
              </h5>
              <h5 className="text-center">{field("videoTitle")}</h5>
            </div>
            {field("videoType") == "halfpage" &&
              (isYouTube(field("videoUrl")) ? (
                <YouTubeVideo videoId={field("videoUrl")} />
              ) : (
                <video id="myVideo" autoplay muted loop className="w-100">
                  <source src={field("videoUrl")} type="video/mp4" />
                </video>
              ))}
          </div>
        </div>
        {field("videoType") == "fullpage" &&
          (isYouTube(field("videoUrl")) ? (
            <YouTubeVideo videoId={field("videoUrl")} />
          ) : (
            <video id="myVideo" autoplay muted loop className="w-100">
              <source src={field("videoUrl")} type="video/mp4" />
            </video>
          ))}
      </section>
    </>
  );
};

export default CampusTourVideo;
